module.exports = __webpack_public_path__ + "static/media/A4.b2f479df.jpg";